import React from "react";
import { Link } from "react-router-dom";
import l from "components/util/l";
import CollaboratorList from "components/presentation/start/stats/CollaborationStats.sub.collaborators.view";


const CollaborationStatsView = ({ user, collaboratorStats }) => (
  <div id="start-activity" className="card">

    <div id="start-activity-container" class="card-body position-relative">
      <h1 id="start-activity-title">
        <i class="fas fa-chart-simple" style={{ marginRight: "0.75rem" }}></i>
        {l("Actividad%VC027")}
      </h1>

      <CollaboratorList
        user={user}
        collaboratorStats={collaboratorStats}
        showMoreDetails={true}
      />

      <Link to="/settings/collaborators" className="btn btn-link float-right mt-1">{l("Ver detalles%SB046")}</Link>

    </div>
  </div>
);


export default CollaborationStatsView;